import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiConfigs } from "../../constants/apiConfigs";
import { PricingData } from "../../types/membership/membershipTypes";
import { isFresh } from "../../utils/helpers";
import { ERROR } from "../../constants/errors";
import { fetchPricing } from "../../services/api/membership";

export interface PricingSlice {
    loading: boolean,
    expired: boolean,
    data: PricingData | null,
    last_fetched_at: number|null
}

export const initialState: PricingSlice = {
    data: null,
    loading: false,
    expired: true,
    last_fetched_at: null
}

const STALE_TIME = apiConfigs.FETCH_PRICING.staleTime;

export const fetchPricingData = createAsyncThunk(
    'pricing/fetch',
    async (force: boolean, {getState, rejectWithValue}) => {
        const state = getState() as {pricing: PricingSlice};
        if(!force && isFresh(state.pricing.last_fetched_at, STALE_TIME) && !state.pricing.expired){
            return rejectWithValue(ERROR.CACHED);
        }

        try {
            const pricingData = await fetchPricing();
            return pricingData;
        } catch (error: any) {
            return rejectWithValue(ERROR.NOT_FOUND);
        }

    }
)

const pricingSlice = createSlice({
    name: 'pricing',
    initialState,
    reducers: {
        markExpired: (state) => {
            state.expired = true;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchPricingData.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchPricingData.fulfilled, (state, data) => {
                state.loading = false;
                state.last_fetched_at = Date.now();
                state.expired = false;
                state.data = data.payload;
            })
            .addCase(fetchPricingData.rejected, (state, data) => {
                state.loading = false;
            })
    }
})

export const {markExpired} = pricingSlice.actions;

export default pricingSlice.reducer;
